import { cn } from "~/lib/utils";

const MATERIAL_VIEWBOX = "0 -960 960 960";

export const NAV_ICON_BOX_CLASS =
  "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gray-200 text-oh-black transition-colors";

type MaterialNavIconProps = {
  path: string;
  className?: string;
};

export function MaterialNavIcon({ path, className }: MaterialNavIconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox={MATERIAL_VIEWBOX}
      className={cn("h-7 w-7 shrink-0 fill-current", className)}
      aria-hidden
    >
      <path d={path} />
    </svg>
  );
}

export function NavIconBox({
  path,
  className,
  boxClassName = NAV_ICON_BOX_CLASS,
}: MaterialNavIconProps & { boxClassName?: string }) {
  return (
    <div className={boxClassName}>
      <MaterialNavIcon path={path} className={className} />
    </div>
  );
}
